import { Button } from '@/shared/ui/button'
import { VLayout } from '@/shared/ui/layouts/flex'
import { VendomeLayout } from '@/shared/ui/layouts/vendome'
import { Typography } from '@/shared/ui/typography'

import { ArrowClockwise, ExclamationTriangleFill } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

export default function Component() {
  const { t } = useTranslation()

  return (
    <VendomeLayout>
      <VLayout items="center" justify="center" gap="4">
        <div className="mx-auto flex flex-col shadow">
          <div className="flex flex-col items-center justify-center gap-8 rounded-xl bg-white p-10">
            <span className="text-warning">
              <ExclamationTriangleFill size={40} aria-hidden="true" />
            </span>
            <div className="text-center">
              <Typography type="heading" variant="h4-bold">
                {t('app.load.errorTitle')}
              </Typography>
              <Typography type="paragraph" as="p" variant="lg">
                {t('app.load.errorSubtitle')}
              </Typography>
            </div>
            <Button
              intent="secondary"
              variant="outline"
              size="lg"
              onClick={() => globalThis.location.reload()}
            >
              <ArrowClockwise />
              {t('app.load.buttonLabel')}
            </Button>
          </div>
        </div>
      </VLayout>
    </VendomeLayout>
  )
}
